import { yup } from '@framework/validation/initYup.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../common/config-slots/WidgetConfigurationSlots.tsx';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent.tsx';
import {
  DecimalSizeConfigInput,
  decimalSizeConfigSchema,
} from '../common/DecimalSizeConfigInput.tsx';
import { type ICurrencyWidget } from './ICurrencyWidget.ts';

export const currencyInputConfigValidator = CommonInputWidgetConfigSchema.shape(
  {
    type: yup.string().exact(WidgetType.Currency).required(),
    decimalSize: decimalSizeConfigSchema,
  },
) satisfies yup.ObjectSchema<ICurrencyWidget>;

export interface ICurrencyWidgetConfigComponentProps
  extends IWidgetComponentProps<ICurrencyWidget> {}

export function CurrencyWidgetConfigComponent(
  props: ICurrencyWidgetConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent {...props} />
      <WidgetConfigurationSlotRender
        slot={WidgetConfigurationSlots.Default}
        order={20}
      >
        <DecimalSizeConfigInput />
      </WidgetConfigurationSlotRender>
    </>
  );
}
